import { ContentType, logUnknownContentType } from 'utils/getContentType';
import { TemplateSettings } from './TemplateSettings/TemplateSettings';
import { DocumentSettings } from './DocumentSettings';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectContentType } from 'components/editor/grid/reduxStore/documentSettingsSlice';

interface Props {
  contentId: string;
}

export function RenderEditorSidePanelSettings({ contentId }: Props) {
  const contentType = useAppSelector(selectContentType);

  switch (contentType) {
    case ContentType.DOCUMENT:
      return <DocumentSettings />;
    case ContentType.TEMPLATE:
      return <TemplateSettings contentId={contentId} />;
    case ContentType.SECTION:
      return null;
    default:
      logUnknownContentType(contentType);
      return null;
  }
}
